import script from "./EmptyData.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyData.vue?vue&type=script&setup=true&lang=js"

import "./EmptyData.vue?vue&type=style&index=0&id=2a743062&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a743062"]])

export default __exports__